module.exports = __webpack_public_path__ + "static/media/Premium 1.b974523b.svg";